import OpenEcg from './OpenEcg';

export default OpenEcg;
